import { Button } from "antd"
import styles from './style.module.less';
import classNames from "classnames"
import { useNavigate } from "react-router"
import { Plan, PlanType } from "@/services/checkout.service"
import { ISubscription } from "@/services/subscription/subscription.service"


interface PackageCardProps {
  className?: string
  plan: Plan
  myPlan?: ISubscription
}
export const PackageCard = (props: PackageCardProps) => {
  const {plan, className, myPlan} = props;
  const navgate = useNavigate();
  const activePlan = myPlan?.plan === plan.name

  const toCheckout = () => {
    navgate('/checkout', {state: {plan}})
  }

  const formatPrice = (price: number) => {
    return Number((price / 100).toFixed(2))
  }

  return <div className={classNames([styles.cardContainer, className, activePlan && styles.activePlan])}>
    <h4 className={styles.cardTitle}>{plan.name}</h4>
    <div className={styles.amount}>{formatPrice(plan.price)}<span className={styles.currency}>{(plan.currency || '').toUpperCase()} / {plan.billingFrequency}</span></div>
    <div className={styles.description}>{plan.description}</div>
    <Button className={classNames('mt-1', styles.checkout)}
      onClick={toCheckout}
      disabled={!!myPlan}
      size="large">Get Start</Button>
    {/* <h5 className={classNames('mt-1', styles.subTitle)}>Free Forever</h5> */}
    <div className={classNames('mt-1', styles.list)}>
      {(plan.features || []).map((item) => <div className={classNames('mt-1', styles.listItem)}>{item.description}</div>)}
    </div>
  </div>
}